// We need to create a context as we cant pass params from fetch data to ag-grid cell renderers.
import React, { useContext } from 'react';
import { CommentsPerInscription } from 'routes/BudgetModule/shared/entities/inscription';

const CommentsPerInscriptionContext = React.createContext<
    CommentsPerInscription | undefined
>(undefined);

export const useCommentsPerInscriptionContext = () =>
    useContext(CommentsPerInscriptionContext);

export default CommentsPerInscriptionContext;
